
export const trim = {
  removeImageExtension,
  jsonExtension,
}

function removeImageExtension(str) {
  return str.replace(/.(png|jp[e]g)$/gi, '')
}

function jsonExtension(str) {
  return str.replace('.json', '')
}
